import React, {useContext, useEffect, Fragment, useState} from "react";
import { observer } from "mobx-react";
import { RootStoreContext } from "../../core/store/rootStore";
import { Table, Button } from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import CompaniesModal from "./companies.modal";

const CompaniesAdministration = () => {
    const rootStore = useContext(RootStoreContext);
    const { loadingList, companiesList, loadCompanies } = rootStore.companiesStore;
    const { openModal } = rootStore.modalStore;

    useEffect(() => {
        loadCompanies();
    }, [loadCompanies]);

    function openCompanyModal() {
        openModal(<CompaniesModal />, null, () => {
            loadCompanies();
        });
    }

    function editCompanyModal(company) {
        openModal(<CompaniesModal />, company, () => {
            loadCompanies();
        });
    }

    return (
        <Fragment>
            <div><b>Gestion de l'entreprise</b></div>
            <div className="row">
                <div className="col-md-12 text-right" style={{ padding: 10 }}>
                    <Button className="btn-primary" onClick={openCompanyModal}>Créer une nouvelle entreprise</Button>
                </div>
            </div>
            <div>
                <LoadingOverlay
                    active={loadingList}
                    spinner>
                    <Table striped>
                        <thead>
                        <tr key={1}>
                            <th>Nom</th>
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        {companiesList.map((company, index) => (
                            <tr key={index}>
                                <td>{company.name}</td>
                                <td className="text-right">
                                    <Button className="btn-primary" onClick={(e) => editCompanyModal(company, e)}>Edition</Button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </LoadingOverlay>
            </div>
        </Fragment>
    );
};

export default observer(CompaniesAdministration);
